// extracted by mini-css-extract-plugin
export default {"root":"notification_root__dLgKC","description":"notification_description__8ult3","title":"notification_title__96D0n","closeButton":"notification_closeButton__550Bn"};